import React from 'react'
import { youtubeIdFor } from "../oneliners"

const YouTubePreview = ({ value, node, ...props }) => {
    if (!value && !node) return <div className="p-3 rounded bg-slate-100 text-slate-700">Invalid URL</div>
    value = value || node
    if (!value.url) return <div className="p-3 rounded bg-slate-100 text-slate-700">Missing URL</div>
    let id = youtubeIdFor(value.url, true)
    let youtubeSrc = `https://www.youtube.com/embed/${id}?autoplay=1&modestbranding=1&controls=1&end=123&showinfo=0&autohide=1`
    return (
        <iframe
            width="560"
            height="315"
            src={`${youtubeSrc}`}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="mx-auto my-4 w-full sm:w-[560px] "
        ></iframe>
    )
}

export default YouTubePreview